import { createSelector, createStructuredSelector } from "reselect";
import { selectUserName } from "scenes/selectors";
import { initialState, State as OktaVerificationState } from "./redux";

/**
 * Direct selector to the oktaVerification state domain
 */

const selectOktaVerificationDomain: (any) => OktaVerificationState = (state) =>
  state.oktaVerification || initialState;

export const selectQRCode = createSelector(
  selectOktaVerificationDomain,
  (substate) => substate.qrCodeLink
);

export const selectStatus = createSelector(
  selectOktaVerificationDomain,
  (substate) => substate.status
);

export const selectQRLinkSubmission = createSelector(
  selectOktaVerificationDomain,
  (substate) => substate.loadingPassCodeSubmission
);

export const selectError = createSelector(
  selectOktaVerificationDomain,
  (substate) => substate.showError
);

export const selectSecretCode = createSelector(
  selectOktaVerificationDomain,
  (substate) => substate.secretCode
);

export const currentFlow = createSelector(
  selectOktaVerificationDomain,
  (subState) => subState.currentFlow
);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  qrCodeLink: selectQRCode,
  status: selectStatus,
  loadingPassCodeSubmission: selectQRLinkSubmission,
  showError: selectError,
  secretCode: selectSecretCode,
  username: selectUserName,
  currentFlow,
});
